module.exports = __webpack_public_path__ + "static/flower-fairies-5b88f13389c254b33f253eab79ca36a6.jpg";